import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton, Divider } from '@mui/material';
import { Close } from '@mui/icons-material';
import DiscountOtpCodeEntry from './DiscountOtpCodeEntry';

// Fallback-path modal only — resumed from ApprovalBanner.js when the cashier
// hands off from DiscountDrawer.js's inline flow (or an OTP-capable org's
// cycle is started straight from the banner). The primary, non-blocking path
// enters the code inline in the drawer with no Dialog at all — see
// DiscountOtpCodeEntry.js, reused by both.
const DiscountOtpModal = ({ open, onClose, cycle, secondsLeft, resendCooldown, isResending, isVerifying, onVerify, onResend }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: { borderRadius: '12px', m: { xs: 2, sm: 3 } } }}
  >
    <DialogTitle sx={{ px: 2.5, py: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography fontWeight={800} fontSize="0.95rem" color="#1E293B">Verify Manager Approval</Typography>
      <IconButton size="small" onClick={onClose} sx={{ color: '#94A3B8', mr: -0.5 }}>
        <Close sx={{ fontSize: 18 }} />
      </IconButton>
    </DialogTitle>

    <Divider />

    <DialogContent sx={{ px: 2.5, py: 2 }}>
      <DiscountOtpCodeEntry
        cycle={cycle}
        secondsLeft={secondsLeft}
        resendCooldown={resendCooldown}
        isResending={isResending}
        isVerifying={isVerifying}
        onVerify={onVerify}
        onResend={onResend}
      />
    </DialogContent>
  </Dialog>
);

export default DiscountOtpModal;
